import React from 'react';
import {
  Configurator,
  ImagePrefetcher,
  Renderer
} from './views';
import {
  generateRendererConfig,
  getImageUrlsFromConfig
} from './renderer/config';
import './App.css';

function isWebWorkerAvailable() {
  if (window.Worker && (window as any).OffscreenCanvas) return true;
  return false;
}

const BLANK_CONFIG = {
  top_color: '',
  middle_color: '',
  bottom_color: '',
  pattern: '',
  texture_1: '',
  texture_2: '',
};

function App() {
  const [config, setConfig] = React.useState<BoatConfig|undefined>(undefined)
  const [selectedConfig, setSelectedConfig] = React.useState<SelectedConfig|undefined>(undefined);
  const [smallRendererConfig, setSmallRendererConfig] = React.useState<RendererConfig|undefined>(undefined);
  const [largeRendererConfig, setLargeRendererConfig] = React.useState<RendererConfig|undefined>(undefined);
  const [smallPreview, setSmallPreview] = React.useState('');
  const [largePreview, setLargePreview] = React.useState('');

  React.useEffect(() => {
    (window as any)._setSelectedConfig = setSelectedConfig;
  }, [])

  React.useEffect(() => {
    if (config && !selectedConfig) {
      let initialRenderConfig: SelectedConfig = BLANK_CONFIG;
      if ((window as any).initialRenderConfig) {
        initialRenderConfig = (window as any).initialRenderConfig as SelectedConfig;
      }
      if ((window as any)._testMode) {
        initialRenderConfig = {
          top_color: config.top_colors.length > 0 ? config.top_colors[0].slug : '',
          middle_color: config.middle_colors.length > 0 ? config.middle_colors[0].slug : '',
          bottom_color: config.bottom_colors.length > 0 ? config.bottom_colors[0].slug : '',
          pattern: config.patterns.length > 0 ? config.patterns[0].slug : '',
          texture_1: config.textures.length > 0 ? config.textures[0].slug : '',
          texture_2: config.second_textures.length > 0 ? config.second_textures[0].slug : ''
        };
      }
      setSelectedConfig(initialRenderConfig);
    }
  }, [config, selectedConfig]);

  React.useEffect(() => {
    console.log(selectedConfig);
    // generate renderer config
    if (config && selectedConfig) {
      setSmallRendererConfig(generateRendererConfig(config, selectedConfig, 'small'));
      setLargeRendererConfig(generateRendererConfig(config, selectedConfig, 'large'));
    }
  }, [config, selectedConfig]);

  const onSmallPreviewRendered = (image: string) => {
    setSmallPreview(image);
    if ((window as any)._onSmallBoatUpdated) (window as any)._onSmallBoatUpdated(image);
  }

  const onLargePreviewRendered = (image: string) => {
    setLargePreview(image);
    if (config?.negative && config.negative.endsWith("/wp-content/plugins/gwd-product-configurator/boats/transparent.png")) {
      console.log('negative not found. skipping callback...');
      return;
    }
    if ((window as any)._onLargeBoatUpdated) {
      (window as any)._onLargeBoatUpdated(image);
    }
  }

  return (
    <div className="GCR">
      <Configurator
        onConfigLoaded={(config) => {setConfig(config)}}
        selectedConfig={selectedConfig ? selectedConfig : BLANK_CONFIG}
        onSelectedConfigUpdated={(selectedConfig) => {
          setSelectedConfig(selectedConfig);
        }}
      />
      {!!(config && smallRendererConfig) && 
        <Renderer
          key="small"
          title="Small Preview"
          config={config}
          selectedConfig={selectedConfig ? selectedConfig : BLANK_CONFIG}
          rendererConfig={smallRendererConfig}
          skipBase
          widthOverride={1220}
          heightOverride={1220}
          onRender={onSmallPreviewRendered}
          renderingMode={config.rendering_mode_small_preview}
        />}
      {!!(config && largeRendererConfig) &&
        <Renderer
          key="large"
          title="Large
          Preview"
          config={config}
          selectedConfig={selectedConfig ? selectedConfig : BLANK_CONFIG}
          rendererConfig={largeRendererConfig}
          onRender={onLargePreviewRendered}
          renderingMode={config.rendering_mode_large_preview}
        />}
      {(!!config && !!smallPreview && !!largePreview) &&
        <ImagePrefetcher
          urls={getImageUrlsFromConfig(config)}
        />
      }
    </div>
  );
}

export default App;
